"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutContextProvider = exports.default = void 0;
const react_1 = __importDefault(require("react"));
const build_context_1 = __importDefault(require("~/components/jsx-helpers/build-context"));
const react_loadable_1 = __importDefault(require("react-loadable"));
const loading_placeholder_1 = __importDefault(require("~/components/loading-placeholder/loading-placeholder"));
const deep_equal_1 = __importDefault(require("deep-equal"));
const loaders = {
    default: () => Promise.resolve().then(() => __importStar(require('~/layouts/default/default'))),
    landing: () => Promise.resolve().then(() => __importStar(require('~/layouts/landing/landing')))
};
const defaultLayoutParameters = { name: 'default' };
function useContextValue() {
    const [layoutParameters, setLayoutParameters] = react_1.default.useReducer((state, newState) => {
        if (newState === undefined) {
            return defaultLayoutParameters;
        }
        if ((0, deep_equal_1.default)(state, newState)) {
            return state;
        }
        return newState;
    }, defaultLayoutParameters);
    const LoadableLayout = react_1.default.useMemo(() => (0, react_loadable_1.default)({
        loader: () => loaders[layoutParameters.name](),
        loading: loading_placeholder_1.default
    }), [layoutParameters.name]);
    const Layout = react_1.default.useCallback(({ children }) => (react_1.default.createElement(LoadableLayout, { data: layoutParameters.data }, children)), [LoadableLayout, layoutParameters.data]);
    return { Layout, setLayoutParameters, layoutParameters };
}
const { useContext, ContextProvider } = (0, build_context_1.default)({ useContextValue });
exports.default = useContext;
exports.LayoutContextProvider = ContextProvider;
